import './App.css';
import React, { Component } from 'react';
import MainCrud from './pages/main';


class App extends Component {
  render() {
    return (
      <div className="App">
        <MainCrud />
      </div>
    );
  }
}

export default App;
